const REFERRAL_TABLE_SUB_HEADERS = [
    { label: 'FIRST NAME',      key: 'firstName' },
    { label: 'MIDDLE NAME',     key: 'middleName' },
    { label: 'LAST NAME',       key: 'lastName' },
    { label: 'PHONE NUMBER',    key: 'phoneNumber' },
    { label: 'EMAIL',           key: 'email'},
    { label: 'DATE CREATED',    key: 'dateCreated' },
    { label: 'STATUS',          key: 'status' },
    { label: 'ACCOUNT TYPE',    key: 'accountType' },
    { label: 'TIER',            key: 'tier' },
    { label: 'REFERRAL COUNT',  key: 'referralCount', },
];



const STATUS_OPTIONS = [
    { label: 'Active',  value: '0' },
    { label: 'Inactive', value: '1' },
];

const ACCOUNT_TYPE_OPTIONS = [
    { label: 'User',     value: '1' },
    { label: 'Merchant', value: '2' },
];

export {
    REFERRAL_TABLE_SUB_HEADERS,
    ACCOUNT_TYPE_OPTIONS,
    STATUS_OPTIONS
}



